export default {
    data() {
        return {
            valid: {
                system_subscription_plan_type: false,
                plan_name: {
                    en: false,
                    el: false
                },
                plan_description: {
                    en: false,
                    el: false
                },
                plan_price: false,
                reward_points: false,
                reward_type: false,
                payment_methods: false,
                interval_count: true
            },
            success: {
                system_subscription_plan_type: false,
                plan_name: false,
                plan_description: false,
                plan_price: false,
                reward_points: false,
                reward_type: false,
                payment_methods: false,
                interval_count: false
            },
            error: {
                system_subscription_plan_type: "",
                plan_name: "",
                plan_description: "",
                plan_price: "",
                reward_points: "",
                reward_type: "",
                payment_methods: "",
                interval_count: ""
            },
            errorMessages: {
                systemSubscriptionPlanTypeRequired: {
                    el: "",
                    en: "System Subscription Plan Type is required",
                    it: ""
                },
                planNameRequired: {
                    el: "",
                    en: "Plan Name is required",
                    it: ""
                },
                planDescriptionRequired: {
                    el: "",
                    en: "Plan Description is required",
                    it: ""
                },
                planPriceRequired: {
                    el: "",
                    en: "Plan Price is required",
                    it: ""
                },
                planPriceMinError: {
                    el: "",
                    en: "Minimum plan price can be 0",
                    it: ""
                },
                rewardPointsRequired: {
                    el: "",
                    en: "Reward Points is required",
                    it: ""
                },
                rewardTypeRequired: {
                    el: "",
                    en: "Reward Type is required",
                    it: ""
                },
                paymentMethodsRequired: {
                    el: "",
                    en: "Payment Methods is required",
                    it: ""
                },
                intervalCountRequired: {
                    el: "",
                    en: "Interval Count is required",
                    it: ""
                }
            }
        };
    },

    computed: {
        formValid() {
            return this.mode === 1
                ? 
                this.valid.plan_name.en &&
                this.valid.plan_name.el && 
                this.valid.plan_description.en &&
                this.valid.plan_description.el &&
                this.valid.reward_points && 
                this.valid.reward_type &&
                this.valid.payment_methods &&
                this.valid.interval_count
                : true;
        }
    },

    methods: {
        validateSystemSubscriptionPlanType() {
            if (!this.subscriptionPlan.system_subscription_plan_type_id) {
                this.error.system_subscription_plan_type = this.errorMessages.systemSubscriptionPlanTypeRequired[
                    this.lang
                ];
            } else {
                this.error.system_subscription_plan_type = "";
            }
        },

        validatePlanName() {
            if (!this.subscriptionPlan.plan_name.el || !this.subscriptionPlan.plan_name.en) {
                this.error.plan_name = this.errorMessages.planNameRequired[
                    this.lang
                ];
            } else {
                this.error.plan_name = "";
            }
        },

        validatePlanDescription() {
            if (!this.subscriptionPlan.plan_description.el || !this.subscriptionPlan.plan_description.en) {
                this.error.plan_description = this.errorMessages.planDescriptionRequired[
                    this.lang
                ];
            } else {
                this.error.plan_description = "";
            }
        },

        validatePlanPrice() {
            if (!this.subscriptionPlan.plan_price) {
                this.error.plan_price = this.errorMessages.planPriceRequired[
                    this.lang
                ];
            } else if(Number(this.subscriptionPlan.plan_price) < 0) {
                this.error.plan_price = this.errorMessages.planPriceMinError[
                    this.lang
                ];
            } else {
                this.error.plan_price = "";
            }
        },

        validateRewardPoints() {
            if (!this.subscriptionPlan.reward_points) {
                this.error.reward_points = this.errorMessages.rewardPointsRequired[
                    this.lang
                ];
            } else {
                this.error.reward_points = "";
            }
        },

        validateRewardType() {
            if (!this.subscriptionPlan.reward_type_id) {
                this.error.reward_type = this.errorMessages.rewardTypeRequired[
                    this.lang
                ];
            } else {
                this.error.reward_type = "";
            }
        },

        validatePaymentMethods() {
            const checkedAttribute = Object.values(this.checkedAttributes).find(
                (attr) => attr
            );
            if(this.subscriptionPlan.plan_price === '0' && !checkedAttribute) {
                this.error.payment_methods = "";
            } else {
                if (this.subscriptionPlan.store_payment_methods.length == 0) {
                    this.error.payment_methods = this.errorMessages.paymentMethodsRequired[
                        this.lang
                    ];
                } else {
                    this.error.payment_methods = "";
                }
            }
        },

        validateIntervalCount() {
            if (this.subscriptionPlan.interval && !this.subscriptionPlan.interval_count) {
                this.error.interval_count = this.errorMessages.intervalCountRequired[
                    this.lang
                ];
            } else {
                this.error.interval_count = "";
            }
        },
    },

    watch: {
        ["subscriptionPlan.system_subscription_plan_type_id"]: {
            immediate: true,
            handler(val) {
                this.valid.system_subscription_plan_type = !!val;
                this.success.system_subscription_plan_type = !!val;
            }
        },

        ["subscriptionPlan.plan_name.en"]: {
            immediate: true,
            handler(val) {
                this.valid.plan_name.en = !!val;
                this.success.plan_name = !!val;
            }
        },

        ["subscriptionPlan.plan_name.el"]: {
            immediate: true,
            handler(val) {
                this.valid.plan_name.el = !!val;
                this.success.plan_name = !!val;
            }
        },

        ["subscriptionPlan.plan_description.en"]: {
            immediate: true,
            handler(val) {
                this.valid.plan_description.el = !!val;
                this.success.plan_description = !!val;
            }
        },

        ["subscriptionPlan.plan_description.el"]: {
            immediate: true,
            handler(val) {
                this.valid.plan_description.en = !!val;
                this.success.plan_description = !!val;
            }
        },

        ["subscriptionPlan.plan_price"]: {
            immediate: true,
            handler(val) {
                this.valid.plan_price = !!val;
                this.success.plan_price = !!val;
            }
        },

        ["subscriptionPlan.reward_points"]: {
            immediate: true,
            handler(val) {
                this.valid.reward_points = !!val;
                this.success.reward_points = !!val;
            }
        },

        ["subscriptionPlan.reward_type_id"]: {
            immediate: true,
            handler(val) {
                this.valid.reward_type = !!val;
                this.success.reward_type = !!val;
            }
        },

        ["subscriptionPlan.store_payment_methods"]: {
            immediate: true,
            handler(val) {
                this.valid.payment_methods = !!val;
                this.success.payment_methods = !!val;
            }
        },

        ["subscriptionPlan.interval_count"]: {
            immediate: true,
            handler(val) {
                this.valid.interval_count = !!val;
                this.success.interval_count = !!val;
            }
        },

        ["subscriptionPlan.interval"]: {
            immediate: true,
            handler(val) {
                if(val) {
                    this.valid.interval_count = !!this.subscriptionPlan.interval_count;
                    this.success.interval_count = !!this.subscriptionPlan.interval_count;
                } else {
                    this.valid.interval_count = true;
                    this.success.interval_count = true;
                }
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    system_subscription_plan_type: false,
                    plan_name: false,
                    plan_description: false,
                    plan_price: false,
                    reward_points: false,
                    reward_type: false,
                    payment_methods: false,
                    interval_count: true
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        system_subscription_plan_type: "",
                        plan_name: "",
                        plan_description: "",
                        plan_price: "",
                        reward_points: "",
                        reward_type: "",
                        payment_methods: "",
                        interval_count: ""
                    };

                    this.setResetValidation(false);
                }
            }
        }
    }
};
